import CurrentCoverageAnalysisStep from './CurrentCoverageAnalysisStep'

export default CurrentCoverageAnalysisStep
